import { render, staticRenderFns } from "./AvailableTasks.vue?vue&type=template&id=59394b0b&scoped=true"
import script from "./AvailableTasks.vue?vue&type=script&lang=js"
export * from "./AvailableTasks.vue?vue&type=script&lang=js"
import style0 from "./AvailableTasks.vue?vue&type=style&index=0&id=59394b0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59394b0b",
  null
  
)

export default component.exports